var _style, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AEB4D7;}\n\t.st1{fill:none;stroke:#020202;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 23.97,
    cy: 28.9,
    rx: 13.66,
    ry: 13.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.61,19.8c0,0,0-8.27,7.57-10.95c-0.7,3.61-1.86,5.01,4.08,12.12c2.1,3.5,8.16,14.68-6.76,18.29 c-2.8,0.23-17.36-0.47-11.18-17.36c1.98-4.08,4.31-7.11,4.31-7.11S23.63,16.42,25.61,19.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/Energy.19e5636d24e1dcc06197cb2fe6daf459.svg";
export { ForwardRef as ReactComponent };